module.exports = __webpack_public_path__ + "static/media/ProfessionalDigital.d65aa5c7.svg";